export default "__VITE_ASSET__d033142c__"